import { Component, inject, afterNextRender, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet, RouterLink } from '@angular/router';
import { ViewportScroller, CommonModule } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


@Component({
  selector: 'app-root',
  imports: [ CommonModule, RouterOutlet, RouterLink],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit{
  public showHeader: boolean;
  public checkShowHeader: boolean;

  public isVisible: boolean;
  public isVisibleSecondary: boolean;
  public blendMode: boolean;

  private lastScrollTop = 0;
  private isMobile = false;

  private _viewportScroller = inject(ViewportScroller);
  private activatedRoute = inject(ActivatedRoute);
  protected title = 'studio';

  constructor(private breakpointObserver: BreakpointObserver) {
    this.showHeader = false;
    this.checkShowHeader = true;
    this.isVisible = true;
    this.isVisibleSecondary = false;
    this.blendMode = false;
  }


  ngOnInit() {
    if(this.breakpointObserver.isMatched('(max-width: 960px)')){
      this.isMobile = true;
      this.isVisibleSecondary = false;
    }
  }

  public onClick(elementId: string): void { 
    console.log('a')
      this._viewportScroller.scrollToAnchor(elementId);
  }

  public showHideSecondaryHeader(): void { 
    this.isVisibleSecondary = !this.isVisibleSecondary;
  }


  @HostListener('window:scroll')
    onViewportScroll() {

      const currentScroll = this._viewportScroller.getScrollPosition()[1];
      // console.log(currentScroll + " "+this._viewportScroller.getScrollPosition());

      if(currentScroll == 0) { 
        // if(!this.isMobile){
        //   this.isVisible = true;
        //   this.isVisibleSecondary = true;
        // }

        this.blendMode = false;
      } else if (currentScroll <= this.lastScrollTop) {
        // scrolling up
        this.isVisible = true;
      } else {
        // scrolling down
        this.isVisible = false;
        this.isVisibleSecondary = false;
        this.blendMode = true;
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

    }


}
